<template>
  <!-- 广告html里,包括属性不能出现任何中英文"广告"关键词,如ad等, 否则会被屏蔽 -->
  <div style="padding: 15px;" v-if="visable && popularize && !isMiniProgram">
    <div class="popularize-title">广告</div>
    <div class="popularize-close" @click="visable=false"><van-icon name="cross" /></div>
    <a :href="popularize.landingPage"><img :src="popularize.creativeImg.creativeUrl" style="width: 100%;"/></a>
  </div>
</template>
<script>
import Axios from 'axios';
import { Icon } from 'vant';
export default {
  name: 'Popularize',
  components: {
    [Icon.name] : Icon
  },
  data() {
    return {
      popularize: null,
      visable: true,
      isMiniProgram : false
    }
  },
  mounted(){
    const that = this;
    this.$wechat.sdk(sdk => {
        sdk.miniProgram.getEnv(function(res) {
          that.isMiniProgram = res.miniprogram;
        })
    });
    this.$http.get('/popularize/fetch_yunzong_popularize', {orderId: this.orderId, spaceId: this.spaceId}).then(resp => {
        that.popularize = resp;
        if (resp.trackUrl) {
          resp.trackUrl.forEach(url => {
          Axios({ method: 'GET', url })
          });
        }
      })
  },
  props: {
    spaceId : String,
    orderId : Number
  }
}
</script>
<style lang="less" scoped>
.popularize-title{display: inline-block; position: absolute;padding: 0 1px; background-color:rgba(0,0,0,0.3);color:white;font-size:12px}
.popularize-close{display: inline-block; position: absolute;padding: 1 4px; background-color:rgba(0,0,0,0.3);color:white;font-size:18px; right: 15px}

</style>